import React, { Component } from 'react'

import TextWithFieldname from './TextWithFieldname';
import ContMessageI18N from '../../containers/ContMessageI18N';

class TableInformation extends Component {

	getLabelHead(valKey){
		return this.getMessage(`${this.props.i18nPrefix}.${valKey}`);
	}

	getLabelValues(valKey){
		if (this.props.values[valKey] == null){
			return '';
		} else {
			var value = this.props.values[valKey];
			if(value != null){
				value = `${value}`;
				value = value.replace('.','\\.');
			}
			var i18nKey = `${this.props.i18nPrefix}.${valKey}.${value}`;
			return this.getMessage(i18nKey,true);
		}
	}
	getMessage(i18nKey,isValue){return <ContMessageI18N i18n={i18nKey} removeI18NPrefix={isValue} />}

	render() {
		var title = this.props.developperView ? null : this.props.title;
		return (
			<TextWithFieldname fieldname={this.props.fieldname} developperView={this.props.developperView} complexChild={true}>
				{title && <h5>{title}</h5>}
				<div className="row shadow rounded p-0 m-1 table-responsive">
					<table className="table table-light table-striped">
						<thead>
							<tr className='table-primary'>
								{Object.keys(this.props.values).map((valKey, index) => (
									<th scope="col" key={index}>
										{this.getLabelHead(valKey)}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							<tr>
								{Object.keys(this.props.values).map((valKey, index) => (
									<td key={index}>
										{this.getLabelValues(valKey)}
									</td>
								))}
							</tr>
						</tbody>
					</table>
				</div>
			</TextWithFieldname>
		)
	}
}

export default (TableInformation)
